import { render, staticRenderFns } from "./purchasePlanDetails.vue?vue&type=template&id=d874f6be"
import script from "./purchasePlanDetails.vue?vue&type=script&lang=js"
export * from "./purchasePlanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports